<div class="navbar-container">
  <betStopReason-component
    page="header"
    [betStopReasonId]="this.betStopReasonEvent.betStopReasonId"
    [teamScore]="this.betStopReasonEvent.teamScore"
    [homeTeamName]="this.betStopReasonEvent.homeTeamName"
    [awayTeamName]="this.betStopReasonEvent.awayTeamName"
    [isLive]="true">
    <div class="box logo-container" [routerLink]="['/home']">
      <image-loader-utils
        extraClasses="logo"
        url="logo"
        [shared]="false"
        [imageFormat]="('product' | getEnv) === 't90' || ('product' | getEnv) === 'cangobet' ? 'svg' : 'png'"></image-loader-utils>
    </div>
  </betStopReason-component>

  <div class="box mid whiteText">
    <div class="navbar-item" [routerLink]="['/sports']" [ngClass]="{ active: currentRoute === '/sports' }">
      {{ 'b3000_sports' | t }}
    </div>
    <div class="navbar-item" [routerLink]="['/live']" [ngClass]="{ active: currentRoute === '/live' }">
      {{ 'b3000_live' | t }}
    </div>
    <ng-container [ngSwitch]="['b500', 'cangobet', 'terminalPeru', 'wettarena-pl'] | getProductName">
      <ng-container *ngSwitchCase="'b500'">
        <ng-container *ngIf="this._UserHelper.isSignedIn">
          <div class="navbar-item" [routerLink]="['/casinolobby']" [ngClass]="{ active: currentRoute === '/casinolobby' }">
            {{ 'LiveCasino' | t }}
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'terminalPeru'">
        <ng-container *ngIf="this._UserHelper.isSignedIn">
          <div class="navbar-item" (click)="openGameCasino()">{{ 'Casino' | t }}</div>
          <div class="navbar-item" [routerLink]="['/casinolobby']" [ngClass]="{ active: currentRoute === '/casinolobby' }">
            {{ 'LiveCasino' | t }}
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'cangobet'">
        <ng-container *ngIf="this._UserHelper.isSignedIn">
          <div class="navbar-item" [routerLink]="['/casinolobby']" [ngClass]="{ active: currentRoute === '/casinolobby' }">
            {{ 'LiveCasino' | t }}
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'wettarena-pl'">
        <ng-container *ngIf="this._UserHelper.isSignedIn">
          <div class="navbar-item" [routerLink]="['/casinolobby']" [ngClass]="{ active: currentRoute === '/casinolobby' }">
            {{ 'LiveCasino' | t }}
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault></ng-container>
    </ng-container>
  </div>

  <div
    class="box account"
    wallet-container-dropdown
    [ngClass]="{
      'sign-in': this._UserHelper.isSignedIn,
      'without-register': !this.IsRegisterActive
    }">
    <ng-container *ngIf="!this._UserHelper.isSignedIn">
      <ng-container [ngSwitch]="['terminalPeru'] | getProductName">
        <ng-container *ngSwitchCase="'terminalPeru'"></ng-container>
        <ng-container *ngSwitchDefault>
          <div class="time-container navbar-right-side-item">
            {{ narvbarDateTime }}
          </div>
        </ng-container>
      </ng-container>

      <ng-container [ngSwitch]="['betarena'] | getProductName">
        <ng-container *ngSwitchCase="'betarena'"></ng-container>
        <ng-container *ngSwitchDefault>
          <div class="btn navbar-small basic login-button btn-h-30 navbar-right-side-item" (click)="loginDropDownOpen()">
            <div class="btn-text">{{ 'login' | t }}</div>
          </div>
        </ng-container>
      </ng-container>
      <div
        [class]="'login-desktop-dropdown navbar-right-side-item ' + (('product' | getEnv) === 'cangobet' || ('product' | getEnv) === 'b500' ? 'full-screen-login' : '')"
        *ngIf="this._UiHelper.loginDropDownIsOpen">
        <ng-container [ngSwitch]="['wettarena', 'b500', 'terminalPeru', 'cangobet'] | getProductName">
          <ng-container *ngSwitchCase="'wettarena'">
            <login-wettarena-component></login-wettarena-component>
          </ng-container>
          <ng-container *ngSwitchCase="'b500'">
            <login-b500-component></login-b500-component>
          </ng-container>
          <ng-container *ngSwitchCase="'cangobet'">
            <login-cangobet-component></login-cangobet-component>
          </ng-container>
          <ng-container *ngSwitchCase="'terminalPeru'">
            <login-terminalPeru-component></login-terminalPeru-component>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <login-b3000-component></login-b3000-component>
          </ng-container>
        </ng-container>
      </div>

      <ng-container [ngSwitch]="['b500'] | getProductName">
        <ng-container *ngSwitchCase="'b500'"></ng-container>
        <ng-container *ngSwitchDefault>
          <div class="btn navbar-small btn-h-30 colored register-button navbar-right-side-item" [routerLink]="['/register']" *ngIf="this.IsRegisterActive">
            <div class="btn-text">{{ 'Register' | t }}</div>
            <div class="btn-icon register-icon">
              <image-loader-utils url="18" extraClasses="svg-18-navbar"></image-loader-utils>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="this._UserHelper.isSignedIn">
      <ng-container [ngSwitch]="['b500', 'terminalPeru'] | getProductName">
        <ng-container *ngSwitchCase="'b500'"></ng-container>
        <ng-container *ngSwitchCase="'terminalPeru'"></ng-container>
        <ng-container *ngSwitchDefault>
          <div class="btn navbar-small btn-h-30 colored register-button navbar-right-side-item" (click)="showTabsMenu(2)">
            <div class="btn-text">{{ 'Transactions_Dialog_Deposit' | t }}</div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container [ngSwitch]="['terminalPeru'] | getProductName">
        <ng-container *ngSwitchCase="'terminalPeru'"></ng-container>
        <ng-container *ngSwitchDefault>
          <div class="timer-container navbar-right-side-item">
            <div class="up-text">
              {{ narvbarDateTime }}
            </div>
            <div class="down-teXt">
              {{ 'last_login' | t }}
              {{ lastLoginDate | dateFormat : 'dd-MM-yyyy,hh:mm a' }}
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-container [ngSwitch]="['terminalPeru'] | getProductName">
        <ng-container *ngSwitchCase="'terminalPeru'"></ng-container>
        <ng-container *ngSwitchDefault>
          <div class="user-info-container navbar-right-side-item">
            <div class="wellcome-text" (click)="showTabsMenu(1)">
              {{ 'Welcome' | t }}, {{ this._UserHelper?.customerUser.UserName }}
              <image-loader-utils url="up-arrow" extraClasses="white-color arrow-icon" [extraClasses]="'white-color arrow-icon ' + (this._UiHelper.tabsMenuIsOpen ? 'up' : 'down')">
              </image-loader-utils>
            </div>
            <ng-container [ngSwitch]="['b500', 'cangobet'] | getProductName">
              <ng-container *ngSwitchCase="'b500'">
                <div class="customer-balance">
                  {{ customerInfo.Balance }}
                </div>
                <div class="wallet-arrow-container"></div>
              </ng-container>
              <ng-container *ngSwitchCase="'cangobet'">
                <div class="customer-balance">
                  {{ customerInfo.Balance }}
                  <div class="wallet-arrow-container"></div>
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="customer-balance" (click)="shopDropDownOpen()">
                  {{ customerInfo.Balance }}
                  <image-loader-utils url="up-arrow" [extraClasses]="'white-color arrow-icon ' + (this._UiHelper.shopDropDownIsOpen ? 'up' : 'down')"> </image-loader-utils>
                </div>
              </ng-container>
            </ng-container>

            <ng-container [ngSwitch]="['b500', 'bettarena'] | getProductName">
              <ng-container *ngSwitchCase="'b500'"></ng-container>
              <ng-container *ngSwitchCase="'bettarena'"></ng-container>
              <ng-container *ngSwitchDefault>
                <div class="cashout-balance" *ngIf="this._UserHelper.customerUser.Bonus != '0.00'">
                  <div class="cashout-logo" matTooltip="{{ 'Cashout' | t }}">CO</div>
                  <span>{{ this._UserHelper?.customerUser?.Bonus | balanceFormat }}</span>
                </div>
              </ng-container>
            </ng-container>

            <div class="wallet-container-dropdown text" *ngIf="this._UiHelper.shopDropDownIsOpen">
              <ng-container *ngIf="this._UserHelper.walletList && this._UserHelper.walletList.length > 0">
                <div *ngFor="let item of this._UserHelper.walletList; let i = index">
                  <div
                    class="shop-row"
                    [ngClass]="{
                      borderB: !(this._UserHelper.walletList.length - 1 === i) || !(this._UserHelper.walletList.length === 1 && i === 0)
                    }"
                    (click)="walletSelectChange(item)">
                    <div class="left-box">
                      <div class="shop-radio">
                        <div
                          class="radio-dot"
                          [ngClass]="{
                            active: item.CustomerId == this._UserHelper.customerUser?.CustomerId
                          }">
                          <div class="dot"></div>
                        </div>
                      </div>
                      <ng-container *ngIf="item.BranchType == 1 || item.BranchType == 2; else type0">
                        <div class="shop-icon">
                          <image-loader-utils url="sports" extraClasses="sportmenusvg"></image-loader-utils>
                        </div>
                        <div class="shop-name" *ngIf="item.BranchType == 1">{{ 'online_sports' | t }}</div>
                        <div class="shop-name" *ngIf="item.BranchType == 2">{{ item.BrancName }}</div>
                      </ng-container>
                    </div>
                    <ng-template #type0>
                      <div class="shop-icon">
                        <image-loader-utils url="shop" extraClasses="shop-icon"></image-loader-utils>
                      </div>
                      <div class="shop-name" style="flex: 1">
                        {{ item.BrancName }}
                      </div>
                    </ng-template>

                    <div class="shop-balance">
                      {{ item.Balance | balanceFormat }}
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
                <ng-container *ngSwitchCase="'wettarena'">
                  <div class="btn navbar-small colored blue btn-credit" (click)="walletCloseButton()">
                    <div class="login-button-text">{{ 'credit' | t }}</div>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'b500'"></ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="btn navbar-small colored blue btn-credit" (click)="walletCloseButton()">
                    <div class="login-button-text">{{ 'credit' | t }}</div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div class="tabs-menu-container" *ngIf="this._UiHelper.tabsMenuIsOpen">
              <div class="tabs-up-header">
                <div class="left-side">{{ 'MyAccount' | t }}</div>
                <div class="right-side" (click)="this._UiHelper.closeShowTabsMenu()">
                  <image-loader-utils url="close" extraClasses="close-icon white-color"></image-loader-utils>
                </div>
              </div>
              <div class="tabs-main-container">
                <account-menu-component menuSelect="accountMenuModal" [userHelper]="this._UserHelper" [UiHelper]="this._UiHelper"></account-menu-component>
                <div class="tabs-content">
                  <slips-component *ngIf="this._UiHelper.tabSelected == 1"></slips-component>
                  <account-credit-component *ngIf="this._UiHelper.tabSelected == 2"></account-credit-component>
                  <bookings-component *ngIf="this._UiHelper.tabSelected == 3"></bookings-component>
                  <deposit-component *ngIf="this._UiHelper.tabSelected == 4"></deposit-component>
                  <user-profile-component *ngIf="this._UiHelper.tabSelected == 5"> </user-profile-component>
                  <self-limits-component *ngIf="this._UiHelper.tabSelected == 6"></self-limits-component>
                  <document-info-upload *ngIf="this._UiHelper.tabSelected == 7"></document-info-upload>
                  <pre-verification-component *ngIf="this._UiHelper.tabSelected == 8"></pre-verification-component>
                  <verification-sow-component *ngIf="this._UiHelper.tabSelected == 11"></verification-sow-component>

                  <bonus-comp *ngIf="this._UiHelper.tabSelected == 9"></bonus-comp>
                  <ng-container *ngIf="this._UiHelper.tabSelected == 10">
                    <ng-container [ngSwitch]="['wettarena', 'b500', 'cangobet'] | getProductName">
                      <ng-container *ngSwitchCase="'wettarena'">
                        <pay3000-wettarena-component></pay3000-wettarena-component>
                      </ng-container>
                      <ng-container *ngSwitchCase="'b500'"></ng-container>
                      <ng-container *ngSwitchCase="'cangobet'"></ng-container>
                      <ng-container *ngSwitchDefault>
                        <pay3000-b3000-component></pay3000-b3000-component>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <div class="lang-button navbar-right-side-item" (click)="langDropdownOpen()">
      <div class="flag">
        <image-loader-utils [url]="_LocalizationService.ISOABBR" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
      </div>
      <div class="languages-dropdown" *ngIf="this._UiHelper.langDropdownIsOpen">
        <div class="dropdown-item" (click)="changeActiveLanguage(x.langCode)" *ngFor="let x of langDatasArry">
          <div class="flag">
            <image-loader-utils [url]="x.ISOabbr" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
          </div>
          <div class="flag-text">{{ x.langNativeNames }}</div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="'isDarkMode' | getEnv">
      <spinner-utils [spinnerState]="this._UiHelper.navbarDarkThemeState">
        <div class="theme-button navbar-right-side-item" (click)="changeTheme()">
          <div class="circle"></div>
        </div>
      </spinner-utils>
    </ng-container>

    <ng-container
      *ngIf="
        this._UiHelper.shopDropDownIsOpen ||
        this._UiHelper.leftMenuIsOpen ||
        this._UiHelper.tabsMenuIsOpen ||
        this._UiHelper.langDropdownIsOpen ||
        this._UiHelper.loginDropDownIsOpen
      ">
      <div class="dimmer" id="dimmer" (click)="closeDimmer()"></div>
    </ng-container>
  </div>
</div>
<div class="navbar-container mobile">
  <div class="menu">
    <div (click)="openLeftMenu()" id="leftMenuIcon">
      <image-loader-utils extraClasses="white-color menu-icon" url="menu"></image-loader-utils>
    </div>
  </div>
  <ng-container [ngSwitch]="['b500'] | getProductName">
    <ng-container *ngSwitchCase="'b500'"></ng-container>
    <ng-container *ngSwitchDefault>
      <div class="search" (click)="goToSportSearch()">
        <image-loader-utils url="search" extraClasses="searchsvg"></image-loader-utils>
      </div>
    </ng-container>
  </ng-container>
  <betStopReason-component
    page="header"
    [betStopReasonId]="this.betStopReasonEvent.betStopReasonId"
    [teamScore]="this.betStopReasonEvent.teamScore"
    [homeTeamName]="this.betStopReasonEvent.homeTeamName"
    [awayTeamName]="this.betStopReasonEvent.awayTeamName"
    [isLive]="true">
    <div class="logo-container" [routerLink]="['/home']" (click)="this._UiHelper.b3000SetMatchDetailDialog('close')">
      <image-loader-utils
        extraClasses="logo"
        url="logo"
        [shared]="false"
        [imageFormat]="('product' | getEnv) === 't90' || ('product' | getEnv) === 'cangobet' ? 'svg' : 'png'"></image-loader-utils>
    </div>
  </betStopReason-component>
  <div class="user" [ngClass]="{ 'user-sign-in': this._UserHelper.isSignedIn }">
    <ng-container [ngSwitch]="['b500', 'bettarena'] | getProductName">
      <ng-container *ngSwitchCase="'b500'">
        <ng-container *ngIf="this._UserHelper.isSignedIn">
          <div class="col" style="margin-right: 5px">
            <div class="user-sign-in-balance">
              {{ customerInfo.Balance }}
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'bettarena'"></ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngIf="this._UserHelper.isSignedIn">
          <div class="col" style="margin-right: 5px">
            <div class="user-sign-in-balance">
              {{ customerInfo.Balance }}
            </div>
            <div class="cashout-balance" *ngIf="this._UserHelper.customerUser.Bonus != '0.00'">
              <div class="cashout-logo">CO</div>
              <span>{{ this._UserHelper?.customerUser?.Bonus | balanceFormat }}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <div id="rightMenuUserIcon" (click)="openSideBar()">
      <image-loader-utils url="user" extraClasses="user-icon white-color"></image-loader-utils>
    </div>
  </div>
  <div id="rightSidenav" class="sidenav">
    <right-menu></right-menu>
  </div>

  <div id="leftSidenav" class="sidenav side-menu-left">
    <left-menu></left-menu>
  </div>
</div>
